import { Modal } from "bootstrap";

export function removeChildren(element: HTMLElement) {
    while (element.children.length > 0) {
        element.removeChild(element.children[0]);
    }
}

export function openModal(selector: string) {
    let modal = Modal.getOrCreateInstance(selector, {backdrop: true});
    modal.show();
}

export function dismissModal(selector: string) {
    let modal = Modal.getOrCreateInstance(selector, {backdrop: true});
    modal.hide();
}

export function isMobile() {
    // detekovanie mobilnych zariadeni prevzate z https://stackoverflow.com/a/26577897
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent);
}

export function isWindowSizeMobile() {
    return (window.innerWidth < 992);
}